<template>
  <div>
    <section class="text-center siteWhy section">
      <div class="bg-why"></div>
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 ml-md-auto">
            <div class="why-content">
              <h3 class="text-white">Why Choose Ardmore Orthopaedic For Shoulder Pain Treatment?</h3>
              <div class="row">
                <div class="col-6" v-for="(why, i) in why" :key="i">
                  <div class="why">
                    <img class="img-fluid" :src="why.icon">
                    <h4 v-html="why.name">{{why.name}}</h4>
                  </div>
                </div>
              </div>
              <p>Orthopaedic Surgeon Dr Ng also specializes in treating other knee & foot conditions. He can help you with other conditions that are also bothering you.</p>
              <a href="#enquire-now" class="site-btn">Enquire About a Consultation Today</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
  .siteWhy {
    background: #040240;
    padding: 0;
    position: relative;
  }
  .bg-why {
    background: url('/images/bg-why.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 40vh;
    position: relative;
  }
  .why-content {
    padding: 60px 0 20px;
  }
  .why-content p {
    color: white;
  }
  .why-content .site-btn {
    margin-bottom: 40px;
  }
  .why {
    margin-bottom: 40px;
  }
  .siteWhy h3 {
    margin-bottom: 40px;
  }
  .siteWhy img {
    height: 80px;
  }
  .siteWhy h4 {
    font-size: 16px;
    color: white;
    line-height: 24px;;
  }
  @media (min-width: 576px) {
    .bg-why {
      height: 50vh;
    }
  }
  @media (min-width: 768px) {
    .bg-why {
      width: 50%;
      height: 100%;;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  @media (min-width: 992px) {
    .why-content  {
      padding: 80px 0 40px 15px;
    }
  }
</style>

<script>
  export default {
    data () {
      return {
        why: [
          {
            icon: '/images/icon-why-01.png',
            name: '<b>Over 10 Years</b><br>of Orthopaedic Experience',
          },
          {
            icon: '/images/icon-why-02.png',
            name: '<b>Conservative Treatments</b><br>as a First Resort',
          },
          {
            icon: '/images/icon-why-03.png',
            name: '<b>Safe & Proven</b><br>Minimally Invasive Surgery',
          },
          {
            icon: '/images/icon-why-04.png',
            name: '<b>Rehabilitation Care</b><br>for Lasting Outcomes',
          }
        ]
      }
    }
  }
</script>